interface MergesWavesFormatterPayload {
  bars: number[]
  waves: number[]
  r_squared: number
}

interface FilledWavesFormatterPayload {
  waves: number[][]
  limits: number[]
  bars: number[]
}

interface IndividualWavesFormatterPayload {
  waves: number[][]
  bars: number[][]
  r_squared: number[]
}

export const formatMergedWavesToPlot = ({
  waves = [],
  bars = [],
  r_squared = 0,
}: MergesWavesFormatterPayload) => {
  const data = waves.reduce((acc, wave, index) => {
    return [...acc, { prediction: wave, real_data: bars[index] || 0 }]
  }, [] as { prediction: number; real_data: number }[])
  return { data, r_squared }
}

export const formatFilledWavesToPlot = ({
  waves = [],
  limits = [],
  bars = [],
}: FilledWavesFormatterPayload) => {
  const biggestLength = waves[0]?.length || 0

  const zeros = new Array(biggestLength).fill(0)

  const normalizedWaves = limits.map((_, index, arr) => {
    const currentLimit = arr[index - 1] || 0

    return [...zeros.slice(0, currentLimit), ...waves[index]]
  })

  const daily_bars = bars.map((bar, index, arr) => {
    const previousBar = arr[index - 1] || 0
    const currentBar = bar
    const result = currentBar - previousBar

    if (result < 0) {
      return 0
    }
    return result
  })

  const data: { [key: string]: number }[] = normalizedWaves[0]?.reduce(
    (acc, _, index) => {
      const position = {} as any
      for (let i = 0; i < normalizedWaves.length; i++) {
        position[`wave_${i + 1}`] = normalizedWaves[i][index]
      }
      position.bar = daily_bars[index] || 0
      return [...acc, position]
    },
    [] as any[]
  )

  return data
}

export const formatFilledMergedWavesToPlot = ({
  waves = [],
  bars = [],
  limits = [],
}: FilledWavesFormatterPayload) => {
  const biggestLength = waves[0]?.length || 0

  const zeros = new Array(biggestLength).fill(0)

  const normalizedWaves = limits.map((_, index, arr) => {
    const currentLimit = arr[index - 1] || 0

    return [...zeros.slice(0, currentLimit), ...waves[index]]
  })

  const data: { [key: string]: number }[] = normalizedWaves[0]?.reduce(
    (acc, _, index) => {
      const position = {} as any
      const wave_buffer = {} as any
      for (let i = 0; i < normalizedWaves.length; i++) {
        wave_buffer[`wave_${i + 1}`] = normalizedWaves[i][index]
      }
      position.prediction = getHeigherValue(wave_buffer)
      position.real_data = bars[index] || 0
      return [...acc, position]
    },
    [] as any[]
  )

  return data
}

export const formatIndividualWavesToPlot = ({
  waves = [],
  bars = [],
  r_squared = [],
}: IndividualWavesFormatterPayload) => {
  const data = waves.map((wave, waveIndex) => {
    return wave.reduce((acc, wv, index) => {
      return [
        ...acc,
        { prediction: wv, real_data: bars[waveIndex][index] || 0 },
      ]
    }, [] as { prediction: number; real_data: number }[])
  })

  return { data, r_squared }
}

export const getHeigherValue = (
  obj: { [key: string]: number } = { key: 0 }
) => {
  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key]
    if (value >= acc) {
      return value
    }
    return acc
  }, obj[Object.keys(obj)[0]] as any)
}

export const getAccumulatedData = (dataset: number[]) =>
  dataset.map((current, index, arr) => {
    const previous = arr[index - 1] || 0
    return previous + current
  })
